// Import dependencies
import React from 'react';
import axios from 'axios';
import queryString from 'query-string';
import cookie from 'js-cookie';
import { tokenize } from '../../../../helper';
import { displayUserAuthAuthorized, displayEmailVerified, displayAffiliateNumber, displayDeviceType } from '../uiAdminHelpers';
import { FaUserCircle, FaStar } from 'react-icons/fa'

import AdminNavbar from '../../../reusables/adminNavbar';
import './MemberDetailPage.css';

// Import config
import config from '../../../../configs/config.json';
const API_URL = config.API_URL;
const ADMIN_API_URL = API_URL + '/admin';
const SETTINGS_URL = ADMIN_API_URL + '/settings';

class MemberDetailPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            memberID: 0,
            memberInfo: {},
            loginHistory: [],
            videoHistory: [],
        }
    }

    componentDidMount() {
        // As the component mounts, check if a token is already stored in the cookie
        var token = cookie.get('token');
        var user_type = cookie.get('user-type');
        if (token) {
            if (user_type === 'admin') {
                // Authorized as admin
            } else {
                // Not authorized as admin, re-direct to log in page
                window.location.href = '/admin/';
            }
        } else {
            // No token found, re-direct to log in page
            window.location.href = '/admin/'
        }

        var { id } = queryString.parse(this.props.location.search, { ignoreQueryPrefix: true });


        if (!id) {
            window.location.href = '/admin/members'
        } else {
            // console.log("ID: ", id)
            this.setState({ memberID: id })
            setTimeout(this.queryMemberDetails, 100);
            setTimeout(this.queryVideoDetails, 100);
        }
    }

    queryMemberDetails = () => {
        axios.get(`${ADMIN_API_URL}/members/details?id=${this.state.memberID}`, tokenize())
            .then(response => {
                var payload = response.data;
                console.log(payload);

                if (payload.success) {
                    var { memberInfo, loginHistory } = payload;
                    this.setState({ memberInfo, loginHistory });
                } else {

                }
            })
            .catch(error => {

            })
    }


    queryVideoDetails = () => {
        axios.get(`${SETTINGS_URL}/analytics/videos?memberId=${this.state.memberID}`, tokenize())
            .then(response => {
                var payload = response.data;
                console.log(payload);

                if (payload.success) {
                    this.setState({ videoHistory: payload.newResult })
                }
            })
            .catch(error => {

            })
    }

    truncate = (input) => input.length > 30 ? `${input.substring(0, 30)}...` : input;

    render() {
        var { name, email, affiliate_code, olli_member_id, special_access, email_verified, created_at } = this.state.memberInfo
        var dateTimeRegistered = new Date(created_at).toLocaleString();

        return (
            <div>
                <AdminNavbar />

                <h1 className='pageTitle'>Detailed Member View</h1>

                <div className='row adminPageSubHeader justify-content-start'>
                    <div className='col-2'>
                        <FaUserCircle size='8em' />
                    </div>
                    <div className='col-10'>
                        <div>Name: {name}</div>
                        <div>Email: {email} {displayEmailVerified(email_verified)}</div>
                        <div>Affiliate: {displayAffiliateNumber(affiliate_code)}</div>
                        <div>{(special_access === 0) ? 'OLLI Member ID' : 'Special Access Code'}: {olli_member_id}</div>
                        <div>Registered: {dateTimeRegistered}</div>
                    </div>
                </div>


                <table className='table table-striped generalTable'>
                    <thead>
                        <tr>
                            <th>Authorized</th>
                            <th>Affiliate Code</th>
                            <th>Device Type</th>
                            <th>IP Address</th>
                            <th>Location</th>
                            <th>Date</th>

                        </tr>
                    </thead>
                    <tbody>
                        {this.state.loginHistory.map((entry, index) => {
                            var entryDateTime = new Date(entry.created_at).toLocaleString();

                            return <tr key={index}>
                                <td>{displayUserAuthAuthorized(entry.authorized)}</td>
                                <td>{displayAffiliateNumber(entry.affiliate_code)}</td>
                                <td>{displayDeviceType(entry.device_type)}</td>
                                <td>{entry.ip_address}</td>
                                <td>{entry.location}</td>
                                <td>{entryDateTime}</td>
                            </tr>
                        })}
                    </tbody>

                </table>

                {
                    this.state.videoHistory.length === 0 ? "" :
                        <React.Fragment>
                            <h1 className='pageTitle'>Videos Watched</h1>

                            <table className='table table-striped generalTable'>
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Partial View</th>
                                        <th>Full View</th>
                                        <th>Viewed At</th>
                                        <th>Rating</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.videoHistory.map((entry, index) => {
                                        var entryDateTime = new Date(entry.created_at).toLocaleString();

                                        return <tr key={index}>
                                            <td>{this.truncate(entry.title)}</td>
                                            <td>{entry.partial_views}</td>
                                            <td>{entry.full_views}</td>
                                            <td>{entryDateTime}</td>
                                            <td>{<FaStar color="orange" textAnchor="0" />}</td>
                                        </tr>
                                    })}
                                </tbody>

                            </table>
                        </React.Fragment>
                }

            </div>
        )
    }
}

export default MemberDetailPage;